import { Outlet } from "react-router-dom";
import HeaderTemplate from "../templates/header/header";
import FooterTemplate from "../templates/footer/footer";
// import NotFound from "../Components/notfound/NotFound";

const PublicLayout = () => {
 

  return (
    <>
      <HeaderTemplate />
      <Outlet />
      <FooterTemplate />
    </>
  );
};

export default PublicLayout;
